import React, { useState, useEffect } from "react";
import moment from "moment";
import { Redirect } from "react-router-dom";
import jsPDF from "jspdf";
import "jspdf-autotable";
import html2canvas from "html2canvas";
import {
  Button,
  Col,
  Row,
  Container,
  FormGroup,
  Input,
  Label,
} from "reactstrap";
import ReactstrapTable from "./../Tables/ReactstrapTable/DataTable";

var companySymbolCurrency = localStorage.getItem("companySymbolCurrency");
var customerName = localStorage.getItem("firstName");
var loginId = localStorage.getItem("username");
var companyName = localStorage.getItem("companyName");
let currentDate = moment(new Date()).format("YYYY-MM-DD");
if (loginId === "SJM_Admin@gmail.com") {
  customerName = loginId.toString().replace(":", "").split("@")[0];
}

export default function PrintReports(props) {
  console.log("props :>> ", props);

  // Get data from localStorage
  const reportState = JSON.parse(localStorage.getItem("reportState") || "{}");
  console.log("reportState :>> ", reportState);

  const [data, setData] = useState({
    dynamicInvMessage: reportState?.dynamicInvMessage || "",
    reportName: reportState?.reportName || "",
    companyName: localStorage.getItem("companyName") || "",
    criteria: reportState?.criteria || [],
    criteriaString: reportState?.criteriaString || "All",
    hidePdfBtn: reportState?.hidePdfBtn || 0,
    goBackUrl: reportState?.goBackUrl || "/",
    headers: reportState?.headers || [],
    headerKeyMap: reportState?.headerKeyMap || [],
    data: reportState?.data || [],
  });
  const [screenTableData, setScreenTableData] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const screenPrintData = reportState.data;
    const reportPrintGoBackUrl = reportState.goBackUrl;

    if (!token) {
      return <Redirect to="/login" />;
    }

    if (!screenPrintData) {
      props.history.push({ pathname: reportPrintGoBackUrl });
      return;
    }

    const modifiedData = screenPrintData.map((row, index, array) => {
      if (
        index > 0 &&
        row.master_invoice_id === array[index - 1].master_invoice_id &&
        row.FINISHED_ITEM === array[index - 1].FINISHED_ITEM &&
        row.master_invoice_id > -1
      ) {
        return {
          ...row,
          INVOICE_DATE: "",
          INVOICE_NO: "",
          FINISHED_ITEM: "",
        };
      }
      return row;
    });

    setScreenTableData(modifiedData);
    // localStorage.removeItem("reportState");
  }, []);

  const goBackFun = () => {
    let pathName = data.goBackUrl;
    props.history.push({
      pathname: pathName,
    });
  };

  const downloadPDF = () => {
    // const reportState = JSON.parse(localStorage.getItem("reportState") || "{}");

    // const headers = [JSON.parse(JSON.stringify(reportState?.headers || []))];

    const headers = [
  reportState.headers.map((h) =>
    h && typeof h === "object" ? h.value : h
  ), // 3 july 2026 do not change this at any cost it will remove header from the pdf prints contact Fahad 
];
    const rawData = JSON.parse(JSON.stringify(reportState?.data || []));
    const pdfData = JSON.parse(
      JSON.stringify(reportState?.pdfDataArray || rawData)
    );

    console.log("pdfDataArray :>> ", pdfData);

    const modifiedPdfDataArray = pdfData.map((row, index, array) => {
      if (
        index > 0 &&
        row.FINISHED_ITEM &&
        row.FINISHED_ITEM === array[index - 1].FINISHED_ITEM
      ) {
        return {
          ...row,
          INVOICE_DATE: "",
          INVOICE_NO: "",
          FINISHED_ITEM: "",
        };
      }
      return row;
    });

    console.log(modifiedPdfDataArray);
    const rowsvalueExtracted = modifiedPdfDataArray.map((item) =>
      Object.values(item)
    );
    console.log("rowsvalueExtracted", rowsvalueExtracted);

    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a2",
    });

    const reportName = reportState?.reportName || "Report"; // Get from localStorage
    const criteriaString = reportState?.criteriaString || "All";

    doc.setFontSize(25);
    doc.text(reportName, 14, 10);
    doc.setFontSize(20);
    doc.text(criteriaString, 14, 20);

    const today = new Date();
    const formattedDate = today.toLocaleDateString("en-US");
    let username = localStorage.getItem("username");
    let companyName = localStorage.getItem("companyName");

    // Generate the table
    doc.autoTable({
      head: headers,
      body: rowsvalueExtracted,
      startY: 22,
      theme: "striped",
      styles: {
        fontSize: 20,
        cellPadding: 2,
      },
      headStyles: { fillColor: [63, 14, 128] },
      didDrawPage: (data) => {
        if (companyName === "Dollar") {
          doc.text(`Generated By: ${username}`, 340, 410);
          doc.text(`Generated on: ${formattedDate}`, 500, 410);
        }

        // Footer example
        doc.text(
          `Page ${doc.internal.getCurrentPageInfo().pageNumber}`,
          10,
          410
        );
      },
      didParseCell: (data) => {
        if (
          data.row.raw[2] === "Sub Total" ||
          (data.row.raw[0] || data.row.raw[1]) === "Total"
        ) {
          data.cell.styles.fontStyle = "bold";
        }
      },
    });

    // Save the PDF
    doc.save(reportName);
    localStorage.removeItem("reportState");
  };

  const {
    companyName,
    dynamicInvMessage,
    reportName,
    criteria,
    criteriaString,
  } = data;

  return (
    <>
      <Row id="app-body-Invoice" className="app-body-Invoice mt-3">
        <Col xs="12">
          <Row>
            <Col xs="6">
              <h2 style={{ marginLeft: "5px" }} className="">
                {companyName}
              </h2>
            </Col>
            <Col xs="4">
              <span style={{ marginLeft: "13em" }}>
                <span className=" ">Printed By </span>: (
                <span className="text-success"> {customerName} </span> )
              </span>
            </Col>
            <Col xs="2">
              <span style={{ marginLeft: "0rem" }}>
                <span className=" ">Printed Date </span>: (
                <span className="text-success"> {currentDate} </span> )
              </span>
            </Col>
            <Col xs="8">
              <h3 style={{ marginLeft: "5px" }} className="">
                {dynamicInvMessage}
              </h3>
            </Col>
            <Col xs="4">
              <div style={{ textAlign: "end" }}>
                {data.hidePdfBtn > 0 ? (
                  <button
                    className="btn btn-primary mx-2"
                    id="printPageButton"
                    onClick={() => {
                      window.document.title = reportName;
                      window.print();
                    }}
                  >
                    Print to PDF!
                  </button>
                ) : (
                  <Button className="btn btn-warning" onClick={downloadPDF}>
                    Print PDF
                  </Button>
                )}
                <button
                  className="btn btn-secondary m-1"
                  id="printPageButton"
                  onClick={goBackFun}
                >
                  Back
                </button>
              </div>
            </Col>

            <Col xs="12">
              <p style={{ marginLeft: "5px" }}>
                <b>Data Criteria: {criteriaString}</b>
              </p>
            </Col>
            {screenTableData.length > 0 ? (
              <Col xs="12">
                <ReactstrapTable
                  data={screenTableData}
                  headers={data.headers}
                  username={loginId}
                  headerKeyMap={data.headerKeyMap}
                  totalBold={reportState.totalBold}
                />
              </Col>
            ) : (
              <p>Loading data...</p>
            )}
            <Col xs="12">
              <p>
                * <span className="text-danger">Note </span>: All figures
                indicated are in the company's currency (
                <span className="text-success"> {companySymbolCurrency} </span>{" "}
                ) .
              </p>
            </Col>
          </Row>
          <br></br>
        </Col>
      </Row>
    </>
  );
}
